import { render, staticRenderFns } from "./PlanetChart.vue?vue&type=template&id=36220ad0&scoped=true&"
import script from "./PlanetChart.vue?vue&type=script&lang=js&"
export * from "./PlanetChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36220ad0",
  null
  
)

export default component.exports